import * as React from 'react';
import { GameType } from '../../../types/GameType.ts';
import { getGameConfig } from '../../../types/GameConfig.ts';
import { getIconComponent } from '../../../utils/iconUtils.ts';
import { useAuth } from '../../../supabase/AuthContext.tsx';

// Helper function to convert hex color to rgba with opacity
const hexToRgba = (hex: string, opacity: number): string => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export function SignInPrompt({ onClose }: { onClose?: () => void }): React.ReactElement | null {
  const { user, openAuthModal } = useAuth();

  if (user) return null;

  return (
    <div className='statsModalRow'>
      <button
        onClick={() => {
          if (onClose) onClose();
          openAuthModal();
        }}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: '#888',
          fontSize: '0.8rem',
          textDecoration: 'underline',
          padding: '4px 0',
        }}
      >
        Sign in to save your stats across devices
      </button>
    </div>
  );
}

interface PlayOtherGameCardsProps {
  currentGameType: GameType;
  onGameSelect: (gameType: GameType) => void;
}

export function getPlayOtherGameCards({
  currentGameType,
  onGameSelect
}: PlayOtherGameCardsProps): React.ReactElement[] {
  // Get all available game types except the current one
  const allGameTypes = Object.values(GameType);
  const otherGameTypes = allGameTypes.filter(gameType => gameType !== currentGameType);
  
  // First filter to get only launched games
  const launchedGameTypes = otherGameTypes.filter(gameType => {
    const gameConfig = getGameConfig(gameType);
    return gameConfig.hasGameLaunched();
  });
  
  // Then map to create the cards with primary color backgrounds
  return launchedGameTypes.map((gameType) => {
    const gameConfig = getGameConfig(gameType);
    const IconComponent = getIconComponent(gameConfig.icon);
    
    return (
      <div 
        key={gameType} 
        className="playOtherGameCard" 
        onClick={() => onGameSelect(gameType)}
        style={{ backgroundColor: hexToRgba(gameConfig.primaryColor, 0.8) }}
      >
        {IconComponent && (
          <IconComponent style={{ width: 48, height: 48 }} />
        )}
        <div className="playOtherGameButtonText">
          Play today's {gameConfig.name}
        </div>
      </div>
    );
  });
} 